import { CRUDEntity } from "../abstracts/CRUDEntity";

export class QuickbooksIntegrationHistory extends CRUDEntity {
    constructor(id=null){
        super();
        this.entityClass = 'quickbooks-sync-historie';
        this.urlRoot = '/quickbooks-integration';
        this.sectionRootUrl = '/quickbooks-integration';
        this.id = id;
    }
}